export default __webpack_public_path__ + "static/media/rotateRight.167d65f0.svg";